import axios from "axios";

export async function login(loginInfo) {
  let url = "https://menuapi.mubatech.com/api/admin/v1/login";
  let data = await axios.post(url, loginInfo);

  console.log(data.data);
  return data.data;
}
